import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'dmp-cron',
    templateUrl: './cron.component.html',
    styleUrls: ['./cron.component.scss'],
    standalone: false
})
export class CronComponent implements OnInit {

    public cronExpression = '0 12 1W 1/1 ?';
    @Input() public disabled = false;

    @Input() get cron(): string {
        return this.cronExpression;
    }

    set cron(value: string) {
        this.cronExpression = value;
        this.cronChange.emit(this.cronExpression);
    }

    @Output() cronChange = new EventEmitter();


    public isCronDisabled = false;
    // public cronOptions: CronOptions = {
    //   formInputClass: 'form-control cron-editor-input',
    //   formSelectClass: 'form-control cron-editor-select',
    //   formRadioClass: 'cron-editor-radio',
    //   formCheckboxClass: 'cron-editor-checkbox',
    //
    //   defaultTime: '10:00:00',
    //   use24HourTime: true,
    //
    //   hideMinutesTab: false,
    //   hideHourlyTab: false,
    //   hideDailyTab: false,
    //   hideWeeklyTab: false,
    //   hideMonthlyTab: false,
    //   hideYearlyTab: false,
    //   hideAdvancedTab: false,
    //
    //   hideSeconds: true,
    //   removeSeconds: true,
    //   removeYears: true,
    //   removeExtendedCron: true
    // };

    // constructor(private cronEditorTranslateService: CronEditorTranslateService,
    //   public translate: TranslateService) {
    //     this.translate.use('en');
    //   cronEditorTranslateService.init({
    //     existent: [{lang: 'en', useExistent: 'en'}],
    //     custom: [
    //       {
    //         lang: 'fr',
    //         translations: {
  //           TABS: {
  //             MINUTES: 'Minutes',
  //             HOURLY: 'Heures',
  //             DAILY: 'Hours',
  //             WEEKLY: 'Semaines',
  //             MONTHLY: 'Mois',
  //             YEARLY: 'Années',
  //             ADVANCED: 'Avancé'
  //           },
  //           MINUTES: {
  //             EVERY: 'Toujours',
  //             MINUTES: 'minute(s)',
  //             ON_SECOND: 'à la seconde'
  //           },
  //           HOURLY: {
  //             EVERY: 'Toujours',
  //             HOURS: 'heure(s)',
  //             ON_MINUTE: 'à la minute',
  //             ON_SECOND: 'et à la seconde'
  //           },
  //           DAILY: {
  //             EVERY: 'Toujours',
  //             DAYS: 'jour(s) à',
  //             WORKING_DAY: 'Jou de travail à'
  //           },
  //           WEEKLY: {
  //             AT: 'à'
  //           },
  //           MONTHLY: {
  //             ON: 'Sur le',
  //             OF_EVERY: 'de chaque',
  //             MONTHS: 'mois',
  //             NEAREST_WEEKDAY: 'le jour de semaine le plus proche',
  //             AT: 'à',
  //             STARTING_IN: 'à partir de'
  //           },
  //           YEARLY: {
  //             EVERY: 'Tous',
  //             ON: 'sur le',
  //             AT: 'à',
  //             OF: 'de',
  //             NEAREST_WEEKDAY: 'le jour de semaine le plus proche'
  //           },
  //           ADVANCED: {
  //             CRON: 'Expression cron'
  //           },
  //           MONTH_DAY: {
  //             LAST_DAY: 'Dernier jour',
  //             LAST_WEEKDAY: 'Dernier jour de la semaine',
  //             FIRST_WEEKDAY: 'Premier jour de la semaine',
  //             DAY_N: 'Jour {{n}}'
  //           },
  //           MONTH_WEEK: {
  //             FIRST: 'Premier',
  //             SECOND: 'Second',
  //             THIRD: 'Troisième',
  //             FOURTH: 'Quatrième',
  //             FIFTH: 'Cinquième',
  //             LAST: 'Dernier'
  //           },
  //           MONTH: {
  //             JANUARY: 'Janvier',
  //             FEBRUARY: 'Février',
  //             MARCH: 'Mars',
  //             APRIL: 'Avril',
  //             MAY: 'Mai',
  //             JUNE: 'Juin',
  //             JULY: 'Juillet',
  //             AUGUST: 'Août',
  //             SEPTEMBER: 'Septembre',
  //             OCTOBER: 'Octobre',
    //             NOVEMBER: 'Novembre',
    //             DECEMBER: 'Décembre'
    //           },
    //           WEEK: {
    //             MON: 'Lundi',
    //             TUE: 'Mardi',
    //             WED: 'Mercredi',
    //             THU: 'Jeudi',
    //             FRI: 'Vendredi',
    //             SAT: 'Samedi',
    //             SUN: 'Dimanche',
    //           },
    //           HOUR_TYPES: {
    //             AM: 'AM',
    //             PM: 'PM'
    //           },
    //           VALIDATION_MESSAGE: {
    //             NULL: "L'expression cron ne peut pas être nulle",
    //             SEGMENTS: 'Expression cron non valide, il doit y avoir {{n}} segments'
    //           }
    //         }
    //       }
    //     ]
    //   });
    //  }
    constructor() {
    }

    ngOnInit(): void {
    }

    doChange(event: any) {
        this.cronChange.emit(this.cronExpression);
    }
}
